import { useCallback, useMemo, useState } from "react";
import { CopyOutlined } from "@ant-design/icons";
import { Button, Input, Modal, message } from "antd";
import { ActionLabel } from "./DownloadAction";
import { useTranslation } from "../../i18n";

function MobileZipSuggestModal({ open, onCancel, onContinueZip }) {
    const { t } = useTranslation();
    const [copying, setCopying] = useState(false);
    const pageUrl = useMemo(
        () => (typeof window !== "undefined" ? window.location.href : ""),
        [open]
    );

    const handleCopy = useCallback(async () => {
        if (!pageUrl) {
            return;
        }

        setCopying(true);
        try {
            await navigator.clipboard.writeText(pageUrl);
            message.success(t("delivery.actions.linkCopied"));
        } catch {
            message.error(t("delivery.actions.linkCopyFailed"));
        } finally {
            setCopying(false);
        }
    }, [pageUrl, t]);

    return (
        <Modal
            open={open}
            title={t("delivery.actions.mobileZipSuggestTitle")}
            onCancel={onCancel}
            footer={[
                <Button key="cancel" onClick={onCancel}>
                    {t("delivery.actions.cancel")}
                </Button>,
                <Button key="continue" type="primary" danger onClick={onContinueZip}>
                    {t("delivery.actions.mobileZipContinue")}
                </Button>,
            ]}
            className="delivery-browser__modal"
            destroyOnClose
        >
            <p>{t("delivery.actions.mobileZipSuggestBody")}</p>
            <div className="delivery-browser__copy-row">
                <Input readOnly value={pageUrl} aria-label="Delivery page URL" />
                <Button icon={<CopyOutlined />} loading={copying} onClick={handleCopy}>
                    <ActionLabel labelKey="copyLink" />
                </Button>
            </div>
        </Modal>
    );
}

export default MobileZipSuggestModal;
